// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/BoschSans-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/BoschSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/BoschSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/BoschSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  border: 0;
  background-color: transparent;
  height: fit-content;
  width: fit-content;
}

body {
  margin: 0;
  background-color: #f9f9f9;
  font-family: "Bosch Sans", sans-serif !important;
}

@font-face {
  font-family: "Bosch Sans";
  src: local("BoschSans-Light"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

@font-face {
  font-family: "Bosch Sans";
  src: local("BoschSans-Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

@font-face {
  font-family: "Bosch Sans";
  src: local("BoschSans-Medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

@font-face {
  font-family: "Bosch Sans";
  src: local("BoschSans-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}

@font-face {
  font-family: "BoschRegular";
  src: local("BoschSans-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}

.pageContainer {
  padding-left: 35px;
}

.pagesContainer {
  padding-top: 20px;
}

.button {
  padding-top: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.lineLabel {
  white-space: pre-line;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB;8DACuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,wFAAkF;AACpF;;AAEA;EACE,yBAAyB;EACzB;8DACwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB;8DACyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B;8DACyD;AAC3D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["button {\n  border: 0;\n  background-color: transparent;\n  height: fit-content;\n  width: fit-content;\n}\n\nbody {\n  margin: 0;\n  background-color: #f9f9f9;\n  font-family: \"Bosch Sans\", sans-serif !important;\n}\n\n@font-face {\n  font-family: \"Bosch Sans\";\n  src: local(\"BoschSans-Light\"),\n    url(\"./fonts/BoschSans-Light.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Bosch Sans\";\n  src: local(\"BoschSans-Bold\"), url(\"./fonts/BoschSans-Bold.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Bosch Sans\";\n  src: local(\"BoschSans-Medium\"),\n    url(\"./fonts/BoschSans-Medium.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Bosch Sans\";\n  src: local(\"BoschSans-Regular\"),\n    url(\"./fonts/BoschSans-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"BoschRegular\";\n  src: local(\"BoschSans-Regular\"),\n    url(\"./fonts/BoschSans-Regular.ttf\") format(\"truetype\");\n}\n\n.pageContainer {\n  padding-left: 35px;\n}\n\n.pagesContainer {\n  padding-top: 20px;\n}\n\n.button {\n  padding-top: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.lineLabel {\n  white-space: pre-line;\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
